import { MenuItem, TextField } from '@mui/material';
import {
  SUPPORTED_UI_LANGUAGES,
  LANGUAGE_META,
  type UiLanguage,
} from '../../i18n/languages';

/**
 * Reusable language dropdown (flag + native label). Single source of the
 * language list — consumed by the Settings UI-language switcher, the report
 * export dialog, and anywhere else a language is picked. Holds NO language
 * logic; it just emits a code from `SUPPORTED_UI_LANGUAGES`.
 */
export default function LanguageSelect({
  value,
  onChange,
  label,
  size = 'small',
  fullWidth = false,
  disabled = false,
}: {
  value: UiLanguage;
  onChange: (lang: UiLanguage) => void;
  label?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  disabled?: boolean;
}) {
  return (
    <TextField
      select
      size={size}
      label={label}
      fullWidth={fullWidth}
      disabled={disabled}
      value={value}
      onChange={(e) => onChange(e.target.value as UiLanguage)}
    >
      {SUPPORTED_UI_LANGUAGES.map((code) => (
        <MenuItem key={code} value={code}>
          {LANGUAGE_META[code].flag}&nbsp;&nbsp;{LANGUAGE_META[code].label}
        </MenuItem>
      ))}
    </TextField>
  );
}
